<template>
  <div class="tooltip-wrapper">
    <slot name="toggle"></slot>
    <div class="custom-tooltip" :class="`${location}`">
      <slot> Shalom from the tooltip! </slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, withDefaults, ref } from "vue";

interface Props {
  location: string;
}

const props = withDefaults(defineProps<Props>(), {
  location: "bottom",
});
</script>
<style lang="scss" scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;

  .custom-tooltip {
    visibility: hidden;
    height: fit-content;
    width: fit-content;
    overflow: hidden;
    max-width: 90vw;
    background-color: #fff;
    border-radius: 6px;
    padding: 15px;
    font-size: 0.9rem;
    font-weight: 400;
    color: #767676;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);

    /* Position the tooltip */
    position: absolute;
    z-index: 1;

    &:before {
      content: " ";
      display: block;
      position: absolute;
      left: 54px;
      bottom: -6px;
      width: 14px;
      height: 14px;
      border-width: 0;
      border-style: none solid solid none;
      background-color: #fff;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
    }

    &.bottom {
      top: 23px;

      &:before {
        top: -7px;
      }
    }

    &.top {
      bottom: 23px;

      &:before {
        bottom: -7px;
      }
    }
  }

  &:hover, &:focus {
    .custom-tooltip {
      visibility: visible;
      min-width: 300px;
    }
  }
}

@media (max-width: 991px) {
  .tooltip-wrapper:hover .custom-tooltip {
    min-width: calc(90vw - 300px);
  }
}
@media screen and (max-width: 800px) {
  .tooltip-wrapper:hover .custom-tooltip {
    min-width: calc(90vw - 200px);
  }
}
@media screen and (max-width: 620px) {
  .tooltip-wrapper:hover .custom-tooltip {
    min-width: calc(90vw - 120px);
  }
}
</style>
